<template>
  <div class="roster-report-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card class="mt-2">
            <b-col cols="12">
              <div class="pull-right date-range-custom">
                <button :class="'btn mode-btn font-weight-600 btn-height'" @click="showHeatMap()">{{ $t('report.submit') }}</button>
              </div>
              <div class="pull-right date-range-custom">
                <b-input-group v-bind:prepend="$t('report.stores')">
                  <multiselect v-model="outletOptions" :options="computedStoreName" :close-on-select="false" :clear-on-select="false" :preserve-search="true" :placeholder="$t('report.pick_some')" label="name_en" track-by="name_en" :preselect-first="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options selected</span>
                    </template>
                  </multiselect>
                </b-input-group>
              </div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card class="mt-2">
            <b-col cols="12">
              <div id="myMap"></div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import DateRangePicker from 'vue2-daterange-picker'
  import DatePicker from 'vue2-datepicker'
  import Multiselect from 'vue-multiselect'
  let cancel = null

  export default {
    name: 'Hotpods',
    components: {
      DateRangePicker,
      DatePicker,
      Multiselect,
    },
    data: function () {
      return {
        value: [],
        options: [],
        outletOptions: []
      }
    },

    methods: {
      nameWithLang({ name, language }) {
        return `${name} — [${language}]`
      },

      /**
       * Get all data outlets and render for select
       */
      getOutletList() {
        let vm = this
        vm.axios.campaign.getStoreListFullDetails(function (response) {
          vm.value = response.data.data.items;
        })
      },

      showHeatMap() {
        let vm = this
        let lat, long = 0
        let wkts = []
        let geolocations = []
        let heatmapData = []
        // if (vm.outletOptions.length > 0) {
        //   vm.outletOptions.forEach(function(item) {
        let item = vm.outletOptions;
        let tradezones = item.coords;
        if (typeof item != 'undefined') {
          geolocations.push({'lat': item.lat, 'lng': item.long});
          lat = item.lat;
          long = item.long;
          let map = new google.maps.Map(document.getElementById('myMap'), {
            zoom: 15,
            center: new google.maps.LatLng(item.lat, item.long)
          });
          let flightPath = new google.maps.Polygon({
            path: tradezones,
            geodesic: true,
            strokeColor: '#fc1e1e',
            strokeWeight: 2,
            zoom: 20,
            fillColor: '#FFF000',
            fillOpacity: 0.2
          });
          flightPath.setMap(map);

          let _data = {
            outlets: '[' + item.id + ']'
          }
          // process to send via get method
          let params = ''
          for (let key in _data) {
            params += key+'='+_data[key]+'&'
          }
          // remove tail
          params = params.slice(0, -1)
          console.log(params);

          vm.axios.campaign.getOutletsOrder(params, function (response) {
            let data = response.data;
            if (typeof data !== 'undefined') {
              let heatmapData = []
              data.map(item => {
                heatmapData.push(new google.maps.LatLng(item.lat, item.long))
              });
              console.log(heatmapData);
              let heatmap = new google.maps.visualization.HeatmapLayer({
                data: heatmapData,
                strokeColor: '#1E90FF',
                strokeOpacity: 0.2,
                strokeWeight: 200,
                fillColor: '#1E90FF',
                fillOpacity: 0.15,
                zoom: 20,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true
              });
              heatmap.setMap(map);
            }
          });
        }
      },
    },

    created: function () {
      this.getOutletList()
    },

    computed: {
      date_locale : function () {
        let format = this.format_date_range_locale()
        if(this.$refs.drange){
          this.$refs.drange.locale = format
        }
        return format
      },
      ranges : function () {
        return this.format_date_ranges()
      },
      computedStoreGroupsName() {
        return this.options.map(function(item) {
          item.name = item.name.en
          return item
        })
      },
      computedStoreName() {
        let vm = this
        if (vm.value.length > 0) {
          let i = 0;
          vm.value.map(item => {
            item.name_en = item.name.en;
            return item;
          })
        };
        return vm.value;
      }
    },

    mounted: function() {
      const element = document.getElementById('myMap')
      const options = {
        zoom: 15,
        center: new google.maps.LatLng(37.775, -122.434),
        disableDoubleClickZoom: true,
        keyboardShortcuts: false
      }
      const map = new google.maps.Map(element, options)
    }
  }
</script>
<style>
  .roster-report-list .date-range-custom .form-control{
    padding: 10px;
  }
  .date-range-custom .multiselect .multiselect__tags {
    border-radius: 0px !important;
    height: 43px;
  }
  .date-range-custom .multiselect {
    min-height: 43px !important;
  }
</style>
<style scoped>
  #myMap {
    height: 680px;
    width: 100%;
  }
  .btn-height {
    max-height: 43px;
    min-height: 43px;
  }
  .pull-right {
    margin-right: 10px;
  }
  .multiselect {
    width: 240px !important;
  }
  .multiselect__select {
    height: 32px !important;
    margin-right: 10px !important;
  }
  .multiselect__single {
    margin-bottom: 7px !important;
    margin-top: 1px !important;
    font-size: 14px !important;
  }
  .multiselect__content-wrapper {
    min-width: 240px;
    max-width: 240px;
  }
  .col-sm-6 {
    float: left;
  }
  .dashboard-stat {
    border-radius: 6px;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    padding: 10px 20px;
    margin-bottom: 10px;
    color: #FFF;
  }
  .icon {
    position: absolute;
    font-size: 5.5em;
    left: 0px;
    top: -10px;
    z-index: 10;
    color: #E4E5E6;
    opacity: 0.3;
  }
  .blue {
    background: #4B8DF8;
    border-bottom: 10px solid #3D85F7;
  }
  .green {
    background: #35AA47;
    border-bottom: 10px solid #319F43;
  }
  .red {
    background: #D84A38;
    border-bottom: 10px solid #D4402E;
  }
  .details {
    text-align: right;
    font-size: 26px;
  }
  .desc {
    font-size: 0.7em;
  }
  .multiselect .multiselect__tags {
    min-height: 35px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0 !important;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 12px;
  }
  .mode-btn {
    background-color: #D4402E;
    color: #FFF;
  }
  .mode-btn:hover {
    background-color: #D84A38;
  }
  .mode-btn:focus {
    background-color: #D84A38;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/report/Hotpods.vue